import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import type { SearchScope } from "../../api/generated";

interface FirefliesSearchInputProps {
  onSearch: (keyword: string, scope: SearchScope) => void;
  onClear: () => void;
}

export function FirefliesSearchInput({
  onSearch,
  onClear,
}: FirefliesSearchInputProps) {
  const [keyword, setKeyword] = useState("");
  const [scope, setScope] = useState<SearchScope>("ALL");

  useEffect(() => {
    if (!keyword.trim()) {
      return;
    }

    const timer = setTimeout(() => {
      onSearch(keyword.trim(), scope);
    }, 400);

    return () => clearTimeout(timer);
  }, [keyword, scope, onSearch]);

  const handleClear = () => {
    setKeyword("");
    onClear();
  };

  return (
    <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
      <TextField
        placeholder="Search transcripts..."
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        fullWidth
        slotProps={{
          input: {
            startAdornment: (
              <SearchIcon sx={{ mr: 1, color: "text.secondary" }} />
            ),
            endAdornment: keyword ? (
              <IconButton size="small" onClick={handleClear}>
                <ClearIcon fontSize="small" />
              </IconButton>
            ) : null,
          }
        }}
      />
      <TextField
        select
        value={scope}
        onChange={(e) => setScope(e.target.value as SearchScope)}
        sx={{ minWidth: 140 }}
      >
        <MenuItem value="ALL">All Fields</MenuItem>
        <MenuItem value="TITLE">Title Only</MenuItem>
        <MenuItem value="SENTENCES">Content</MenuItem>
      </TextField>
    </Box>
  );
}
